module.exports = {"download":"Download CSV"}